import { styled } from "styled-components";
import { useContactContext } from "Components/ContactContext";

export const Footer = () => {
  const { setShowContact } = useContactContext();
  return (
    <Container>
      <span>&copy; {new Date().getFullYear()} SET</span>
      <Links>
        <a href="https://set.tools/" target="_blank" rel="noreferrer">
          About SET
        </a>
        <a
          href={`${process.env.REACT_APP_SL_URL}/privacy`}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        <a
          href={`${process.env.REACT_APP_SL_URL}/terms`}
          target="_blank"
          rel="noreferrer"
        >
          Fan Terms of Use
        </a>
        <a
          href={`${process.env.REACT_APP_SL_URL}/artist-terms`}
          target="_blank"
          rel="noreferrer"
        >
          Artist Terms of Use
        </a>
        <a href={`#contact`} onClick={() => setShowContact(true)}>
          Contact Us
        </a>
        {/* <a href="/" target="_blank">
          FAQ
        </a> */}
      </Links>
    </Container>
  );
};

const Container = styled.div`
  z-index: 1;
  display: flex;
  justify-content: center;
  padding: 0 40px 32px;
  position: relative;
  width: 100%;
  color: #fff;

  span {
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;
  }

  @media (max-width: 980px) {
    flex-direction: column-reverse;
    align-items: center;
    gap: 20px;
  }

  @media (min-width: 981px) {
    span {
      position: absolute;
      left: 44px;
    }
  }
`;

const Links = styled.div`
  display: flex;
  gap: 30px;

  a {
    text-decoration: none;
    color: inherit;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }

  ${({ theme }) => theme.media.mobile} {
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    padding-bottom: 20px;
    max-width: 310px;

    a {
      flex-shrink: 0;
    }
  }
`;
